/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NormativeAccessControllerDownloadDocument200ResponseData { 
    documentId?: string;
    code?: string;
    name?: string;
    versionId?: string;
    version?: string;
    versionStatus?: string;
    fileId?: string;
    /**
     * Nombre con el que se entrega el archivo, con la nomenclatura oficial del documento
     */
    fileName?: string;
    /**
     * MIME real del archivo
     */
    mimeType?: string;
    /**
     * true solo para PDF: el resto de los formatos no se puede abrir en el visor, se descarga
     */
    viewable?: boolean;
    mode?: NormativeAccessControllerDownloadDocument200ResponseData.ModeEnum;
    disposition?: NormativeAccessControllerDownloadDocument200ResponseData.DispositionEnum;
    /**
     * Liga firmada a /secure-files/{fileId}?token=...; expira en minutos
     */
    url?: string;
    expiresAt?: string;
}
export namespace NormativeAccessControllerDownloadDocument200ResponseData {
    export type ModeEnum = 'view' | 'download';
    export const ModeEnum = {
        View: 'view' as ModeEnum,
        Download: 'download' as ModeEnum
    };
    export type DispositionEnum = 'inline' | 'attachment';
    export const DispositionEnum = {
        Inline: 'inline' as DispositionEnum,
        Attachment: 'attachment' as DispositionEnum
    };
}


